import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef } from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import moment from 'moment';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';
import { NumericFormat } from 'react-number-format';
import Button from '@mui/material/Button';
import SelectEventDateForm from './SelectEventDateForm';
import { FormControl, InputLabel, Select, MenuItem, Autocomplete, Box, Grid, Typography, useMediaQuery, useTheme, InputAdornment } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';

import MaterialPhoneInput from '../utils/MaterialPhoneInput'

const ErrorMessageStyled = styled.span`
  color: #d32f2f;
  font-size: 0.75rem;
  margin: 0;
  padding: 0;
  margin-bottom: 25px;
  margin-top: 2px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.66;
    letter-spacing: 0.03333em;
    text-align: left;
    margin-top: 3px;
    margin-right: 0;
    margin-bottom: 0;
    margin-left: 0;
    margin-left: 14px;
    margin-right: 14px;
`;

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, values, handleChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="(#00) 000-0000"
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const NumericFormatCustom = React.forwardRef(
  function NumericFormatCustom(props, ref) {
    const { onChange, values, handleChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
        prefix="RD$"
      />
    );
  },
);

NumericFormatCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

const formatCurrency = (value) => {
  return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const safeParseFloat = (value, defaultValue = 0) => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const parsed = parseFloat(value.replace(/,/g, ''));
    return isNaN(parsed) ? defaultValue : parsed;
  }
  return defaultValue;
};

const EventFormBirthday = forwardRef((props, ref) => {
  const { handleFormValues, formValues, nextStepHandler, reservationStep, clients, requestClients } = props;
  const formRef = useRef(null);
  const [eventDate, setEventDate] = useState();
  const [clientType, setClientType] = useState('new');
  const [clientsList, setClientsList] = useState([]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useImperativeHandle(ref, () => ({
    handleSubmit: () => {
      if (formRef.current) {
        formRef.current.submitForm();
      }
    },
  }));

  const handleEventDate = (date) => {
    setEventDate(date);
  };

  const handleClientTypeChange = (event) => {
    setClientType(event.target.value);
  };

  const handleReservationInf = async (values) => {
    const formValues = {
      client: {
        clientName: values.fatherName,
        phoneNumber: values.fatherPhone,
        cellPhoneNumber: values.fatherCellphone,
        clientEmail: values.fatherEmail,
        address: values.address1,
      },
      birthdaydude: {
        name: values.birthdaydudeName,
        cellphoneNumber: values.birthdaydudeCellphone,
        email: values.birthdayDudeEmail,
        birthday: values.birthday,
      },
      event: {
        eventDateStart: moment(eventDate.start).format('YYYY-MM-DD HH:mm:ss'),
        eventDateEnd: moment(eventDate.end).format('YYYY-MM-DD HH:mm:ss'),
        eventType: values.eventType,
        eventLocation: values.eventPlace,
        eventTitle: `Cumpleaños de ${values.birthdaydudeName}`,
        eventDescription: `${values.comboName} - ${values.eventPlace}`,
      },
      reservation: {
        comboName: values.comboName,
        comboPrice: values.comboPrice,
        deposit: 2000,
        paymentStatus: 'pendiente',
        referralSource: values.referralSource,
        discount: values.discount,
        notes: values.notes
      },
      reservationCashFlow: {
        paymentMethod: 'efectivo',
        amount: 2000,
        description: `Reserva de combo (${values.comboName}) - ${Object.keys(values.eventPlace).length > 0 ? values.eventPlace : 'Sesión en estudio.'}`,
        ServiceID: 24,
        flowType: 'ingreso',
      },
      reservationServices: {
        serviceQty: 1,
        serviceID: 24,
        discount: values.discount,
        status: 'pendiente',
        servicePrice: values.comboPrice
      }
    };

    handleFormValues(formValues);
    nextStepHandler();
  };

  const handleFormSubmit = async (values) => {
    return await handleReservationInf(values);
  };

  useEffect(() => {
    window.onbeforeunload = () => {
      window.scrollTo(0, 0);
    };
  }, []);

  useEffect(() => {
    //console.log(clients, 'Clients');
    if (clients && clients.length > 0) {
      const options = clients
        .filter(client => client.clientName !== 'Cliente al contado') // Filtrar cliente "Contado"
        .map((client) => ({
          label: `${client.clientName} - ${client.cellphoneNumber}`,
          value: client
        }));
      setClientsList([...options]);
    }
    else {
      requestClients();
    }
  }, []);

  useEffect(() => {
    if (clients && clients.length > 0) {
      const options = clients
        .filter(client => client.clientName !== 'Cliente al contado') // Filtrar cliente "Contado"
        .map((client) => ({
          label: `${client.clientName} - ${client.cellphoneNumber}`,
          value: client
        }));
      setClientsList([...options]);
    }
    else {
      requestClients();
    }
  }, [clientType]);

  useEffect(() => {
    if (formValues?.client?.clientID) {
      setClientType('existing');
    }
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: '100%',
        overflowX: 'hidden'
      }}
    >
      <Typography
        variant={isMobile ? 'h5' : 'h4'}
        sx={{
          color: '#f759ab',
          marginBottom: '30px',
          textAlign: 'center',
          mt: { xs: 2, sm: 3, md: 4 },
        }}
      >
        Formulario de reservación de cumpleaños
      </Typography>

      <Box
        sx={{
          width: isMobile ? '90%' : '75%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Formik
          initialValues={{
            fatherName: formValues.client?.clientName || '',
            fatherPhone: formValues.client?.phoneNumber || '',
            fatherCellphone: formValues.client?.cellPhoneNumber || '',
            fatherEmail: formValues.client?.clientEmail || '',
            address1: formValues.client?.address || '',
            birthdaydudeName: formValues.birthdaydude?.name || '',
            birthday: formValues.birthdaydude?.birthday || '',
            birthdaydudeCellphone: formValues.birthdaydude?.cellphoneNumber || '',
            birthdayDudeEmail: formValues.birthdaydude?.email || '',
            eventDate: eventDate,
            comboName: formValues.reservation?.comboName || '',
            comboPrice: formValues.reservation?.comboPrice || '',
            reservationPayment: formValues.reservation?.deposit || '',
            referralSource: Object.keys(formValues).length > 0 ? formValues.reservation.referralSource : '',
            eventType: formValues.event?.eventType || null,
            eventPlace: formValues.event?.eventLocation || '',
            discount: Object.keys(formValues).length > 0 ? formValues.reservation.discount : 0,
            notes: Object.keys(formValues).length > 0 ? formValues.reservation.notes : '',
          }}

          onSubmit={(values, { setSubmitting }) => {
            handleFormSubmit(values);
            setSubmitting(false);
          }}
          validate={values => {
            const errors = {};

            if (!values.fatherName) {
              errors.fatherName = 'El nombre del padre o tutor es requerido';
            }

            if (!values.fatherEmail) {
              errors.fatherEmail = 'El correo electrónico del padre o tutor es requerido';
            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.fatherEmail)) {
              errors.fatherEmail = 'Correo electrónico inválido';
            }

            if (!values.fatherCellphone) {
              errors.fatherCellphone = 'El número de celular del padre o tutor es requerido';
            } else if (values.fatherCellphone.length < 10) {
              errors.fatherCellphone = 'El número de celular debe tener al menos 10 dígitos';
            }

            if (!values.birthdaydudeName) {
              errors.birthdaydudeName = 'El nombre del cumpleañero es requerido';
            }

            if (!values.birthday) {
              errors.birthday = 'La fecha de cumpleaños es requerida';
            }

            if (!values.eventType || values.eventType === '') {
              errors.eventType = 'El tipo de evento es requerido';
            }

            if (!values.eventPlace) {
              errors.eventPlace = 'El lugar del evento es requerido';
            }

            if (!values.comboName) {
              errors.comboName = 'El nombre del combo es requerido';
            }

            if (!values.comboPrice || values.comboPrice <= 0) {
              errors.comboPrice = 'El precio del combo debe ser mayor a 0';
            } else if (values.comboPrice < 6000) {
              errors.comboPrice = 'El precio del combo debe ser al menos RD$6000';
            }

            if (!eventDate || eventDate === '' || eventDate.start === '' || eventDate.end === '') {
              errors.eventDate = 'La fecha del evento es requerida';
            }

            return errors;
          }}
          innerRef={formRef}
        >
          {({
            isSubmitting,
            errors,
            touched,
            setFieldValue,
            handleSubmit,
            handleChange,
            values,
          }) => (
            <Form>
              <Box
                sx={{
                  border: '2px solid #ff85c0',
                  borderRadius: '5px',
                  padding: '20px',
                  marginBottom: '15px',
                }}
              >
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  sx={{
                    fontWeight: 'bold',
                    color: '#fff',
                    backgroundColor: '#ffadd2',
                    padding: '10px',
                    borderRadius: '16px',
                    marginBottom: '20px',
                  }}
                >
                  Información del padre o tutor
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      select
                      label="Tipo de Cliente"
                      value={clientType}
                      onChange={handleClientTypeChange}
                      variant="outlined"
                      fullWidth
                    >
                      <MenuItem value="new">Nuevo Cliente</MenuItem>
                      <MenuItem value="existing">Cliente Registrado</MenuItem>
                    </TextField>
                    <ErrorMessage name='clientType' component={ErrorMessageStyled} />
                  </Grid>

                  {clientType === 'new' && (
                    <>
                      <Grid item xs={12} sm={6}>
                        <Field name="fatherName">
                          {({ field }) => (
                            <TextField
                              {...field}
                              label="Nombre"
                              variant="outlined"
                              fullWidth
                              error={Boolean(errors.fatherName && touched.fatherName)}
                              helperText={touched.fatherName && errors.fatherName}
                            />
                          )}
                        </Field>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Field name="fatherEmail">
                          {({ field }) => (
                            <TextField
                              {...field}
                              label="Email"
                              variant="outlined"
                              fullWidth
                              error={Boolean(errors.fatherEmail && touched.fatherEmail)}
                              helperText={touched.fatherEmail && errors.fatherEmail}
                            />
                          )}
                        </Field>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Field name='fatherPhone'>
                          {({ field, form, meta }) => (
                            <MaterialPhoneInput
                              label="Número de teléfono"
                              name={field.name}
                              value={field.value}
                              onChange={(phone) => {
                                form.setFieldValue(field.name, phone);
                              }}
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                              color={meta.error ? 'error' : (!meta.error && meta.touched ? 'success' : undefined)}
                              labelFontSize={18}
                              defaultCountry="do" // Puedes pasar cualquier otra prop de PhoneInput aquí
                              Autocomplete='clientCellphone'
                            />
                          )}
                        </Field>
                        <ErrorMessage name='fatherCellphone' component={ErrorMessageStyled} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Field name='fatherCellphone'>
                          {({ field, form, meta }) => (
                            <MaterialPhoneInput
                              label="Número de celular"
                              name={field.name}
                              value={field.value}
                              onChange={(phone) => {
                                form.setFieldValue(field.name, phone);
                              }}
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                              color={meta.error ? 'error' : (!meta.error && meta.touched ? 'success' : undefined)}
                              labelFontSize={18}
                              defaultCountry="do" // Puedes pasar cualquier otra prop de PhoneInput aquí
                              Autocomplete='clientCellphone'
                            />
                          )}
                        </Field>
                        <ErrorMessage name='fatherCellphone' component={ErrorMessageStyled} />
                      </Grid>
                      <Grid item xs={12}>
                        <Field name="address1">
                          {({ field }) => (
                            <TextField {...field} label="Dirección de residencia" variant="outlined" fullWidth />
                          )}
                        </Field>
                      </Grid>
                    </>
                  )}
                  {clientType === 'existing' && (
                    <Grid item xs={12}>
                      <Grid item xs={12}>
                        <Autocomplete
                          freeSolo
                          options={clientsList}
                          getOptionLabel={(option) => option.label}
                          value={
                            clientsList.find(option => option.value.clientName === values.fatherName)
                            || values.fatherName || clientsList[0]?.clientName
                          }
                          renderInput={(params) => (
                            <TextField {...params} label="Nombre o celular" variant="outlined" />
                          )}
                          onChange={(event, value) => {
                            if (value && typeof value === 'object') {
                              setFieldValue('fatherName', value.value.clientName);
                              setFieldValue('fatherPhone', value.value.phoneNumber);
                              setFieldValue('fatherCellphone', value.value.cellphoneNumber);
                              setFieldValue('fatherEmail', value.value.clientEmail);
                              setFieldValue('address1', value.value.address);
                              setFieldValue('clientID', value.value.clientID);
                            } else {
                              setFieldValue('fatherName', value || '');
                              setFieldValue('fatherPhone', '');
                              setFieldValue('fatherCellphone', '');
                              setFieldValue('fatherEmail', '');
                              setFieldValue('address1', '');
                              setFieldValue('clientID', null);
                            }
                          }}
                        />
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Box>

              <Box
                sx={{
                  border: '2px solid #ff85c0',
                  borderRadius: '5px',
                  padding: '20px',
                  marginBottom: '15px',
                }}
              >
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  sx={{
                    fontWeight: 'bold',
                    color: '#fff',
                    backgroundColor: '#ffadd2',
                    padding: '10px',
                    borderRadius: '16px',
                    marginBottom: '20px',
                  }}
                >
                  Información del cumpleañero
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Field name="birthdaydudeName">
                      {({ field }) => (
                        <TextField
                          {...field}
                          label="Nombre del cumpleañero"
                          variant="outlined"
                          fullWidth
                          error={Boolean(errors.birthdaydudeName && touched.birthdaydudeName)}
                          helperText={touched.birthdaydudeName && errors.birthdaydudeName}
                        />
                      )}
                    </Field>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field name="birthday" type="date">
                      {({ field }) => (
                        <TextField
                          {...field}
                          label="Fecha de Cumpleaños"
                          variant="outlined"
                          type="date"
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          error={Boolean(errors.birthday && touched.birthday)}
                          helperText={touched.birthday && errors.birthday}
                        />
                      )}
                    </Field>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field name='birthdaydudeCellphone'>
                      {({ field, form, meta }) => (
                        <MaterialPhoneInput
                          label="Celular del cumpleañero"
                          name={field.name}
                          value={field.value}
                          onChange={(phone) => {
                            form.setFieldValue(field.name, phone);
                          }}
                          error={meta.touched && Boolean(meta.error)}
                          helperText={meta.touched && meta.error}
                          color={meta.error ? 'error' : (!meta.error && meta.touched ? 'success' : undefined)}
                          labelFontSize={18}
                          defaultCountry="do" // Puedes pasar cualquier otra prop de PhoneInput aquí
                          Autocomplete='birthdaydudeCellphone'
                        />
                      )}
                    </Field>
                    <ErrorMessage name='birthdaydudeCellphone' component={ErrorMessageStyled} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field name="birthdayDudeEmail" type="email">
                      {({ field }) => (
                        <TextField
                          {...field}
                          label="Email del cumpleañero"
                          variant="outlined"
                          fullWidth
                          initialValues={formValues.length > 0 && formValues.XV.XVEmail}
                        />
                      )}
                    </Field>
                  </Grid>
                </Grid>
              </Box>

              <Box
                sx={{
                  border: '2px solid #ff85c0',
                  borderRadius: '5px',
                  padding: '20px',
                  marginBottom: '15px',
                }}
              >
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  sx={{
                    fontWeight: 'bold',
                    color: '#fff',
                    backgroundColor: '#ffadd2',
                    padding: '10px',
                    borderRadius: '16px',
                    marginBottom: '20px',
                  }}
                >
                  Información del evento
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Field name="eventType">
                      {({ field, form }) => (
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-autowidth-label">Tipo de evento</InputLabel>
                          <Select
                            labelId="simple-select-autowidth-label"
                            id="simple-select-autowidth"
                            value={field.value || ''}
                            onChange={(event) => {
                              values.eventType = event.target.value
                              form.setFieldValue(field.name, event.target.value);
                            }}
                            label="Tipo de evento"
                            error={Boolean(errors.eventType && touched.eventType)}
                            helperText={touched.eventType && errors.eventType}
                          >
                            <MenuItem key='outside' value='outside'>Evento en exterior</MenuItem>
                            <MenuItem key='inside' value='inside'>Evento en estudio</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    </Field>
                    <div style={{ zIndex: 999 }}>
                      <ErrorMessage name='eventType' component={ErrorMessageStyled} />
                    </div>
                  </Grid>
                  {values.eventType === 'inside' &&
                    <Grid item xs={6}>
                      <Field name="eventDate" type="date">
                        {({ field }) => (
                          <SelectEventDateForm {...field}
                            labelName='Fecha del evento (Estudio)'
                            handleEventDate={handleEventDate} typeOfEvent='inside'
                            eventDate={Object.keys(formValues).length > 0 ? formValues.event.eventDateStart : eventDate}
                          />
                        )}
                      </Field>
                      <ErrorMessage name='eventDate' component={ErrorMessageStyled} />
                    </Grid>
                  }
                  {values.eventType === 'outside' &&
                    <Grid item xs={6}>
                      <Field name="eventDate" type="date">
                        {({ field }) => (
                          <SelectEventDateForm {...field}
                            labelName='Fecha del evento en exterior'
                            handleEventDate={handleEventDate} typeOfEvent='outside'
                            eventDate={Object.keys(formValues).length > 0 ? formValues.event.eventDateStart : eventDate}
                          />
                        )}
                      </Field>
                      <ErrorMessage name='eventDate' component={ErrorMessageStyled} />
                    </Grid>
                  }
                  <Grid item xs={12} sm={6}>
                    <Field name="eventPlace">
                      {({ field }) => (
                        <TextField {...field} label="Lugar del evento" variant="outlined" disabled={values.eventType === 'inside'}
                          value={values.eventType === 'inside' ? 'Sesión en estudio.' : field.value} fullWidth
                          error={Boolean(errors.eventPlace && touched.eventPlace)}
                          helperText={touched.eventPlace && errors.eventPlace}
                        />
                      )}
                    </Field>
                  </Grid>
                  <Grid item xs={12} sm={6} fullWidth>
                    <Field name="referralSource" fullWidth>
                      {({ field, form }) => (
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-autowidth-label">¿Cómo escucho de nosotros?</InputLabel>
                          <Select
                            labelId="simple-select-autowidth-label"
                            id="simple-select-autowidth"
                            value={field.value || 'fuente-desconocida'}
                            onChange={(event) => {
                              values.referralSource = event.target.value
                              form.setFieldValue(field.name, event.target.value);
                            }}
                            label="¿Cómo escucho de nosotros?"
                          >
                            <MenuItem key='instagram' value='instagram'>Instagram</MenuItem>
                            <MenuItem key='facebook' value='facebook'>Facebook</MenuItem>
                            <MenuItem key='google' value='google'>Google</MenuItem>
                            <MenuItem key='Referido' value='Referido'>Referido</MenuItem>
                            <MenuItem key='other' value='other'>Otro</MenuItem>
                            <MenuItem key='fuente-desconocida' value='fuente-desconocida'>Fuente desconocida</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    </Field>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field name="comboName">
                      {({ field }) => (
                        <TextField {...field} label="Nombre del Combo" variant="outlined" fullWidth
                          error={Boolean(errors.comboName && touched.comboName)}
                          helperText={touched.comboName && errors.comboName}
                        />
                      )}
                    </Field>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field name="comboPrice">
                      {({ field }) => (
                        <TextField
                          label="Precio del combo"
                          value={values.comboPrice}
                          onChange={handleChange}
                          name="comboPrice"
                          id="formatted-NumberFormat-input"
                          slotProps={{
                            input: {
                              inputComponent: NumericFormatCustom,
                              values: values,
                              handleChange: handleChange,
                            },
                          }}
                          variant="outlined"
                          fullWidth
                          error={Boolean(errors.comboPrice && touched.comboPrice)}
                          helperText={touched.comboPrice && errors.comboPrice}
                        />
                      )}
                    </Field>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Field name="discount">
                      {({ field }) => (
                        <TextField
                          {...field}
                          id="outlined-basic"
                          label="Descuento (%)"
                          variant="outlined"
                          value={values.discount}
                          type="number"
                          inputProps={{
                            min: 0,
                            max: 35,
                            step: 1
                          }}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Solo permitir números enteros positivos menores a 36
                            if (value === '' || (Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) < 36)) {
                              handleChange(e);
                            }
                          }}
                          helperText="Máximo 35%"
                          fullWidth
                        />
                      )}
                    </Field>
                  </Grid>

                  <Grid item xs={12} sm={6} fullWidth>
                    <Field name="totalPrice" fullWidth>
                      {({ field }) => (
                        <TextField fullWidth {...field} id="outlined-basic" label="Precio total" variant="outlined" disabled
                          value={`RD$ ${formatCurrency(safeParseFloat(values.comboPrice || 0) * ((100 - safeParseFloat(values.discount || 0)) / 100))}`} />
                      )}
                    </Field>
                    <ErrorMessage name='totalPrice' component={ErrorMessageStyled} />
                  </Grid>
                  <Grid item xs={12}>
                    <Field name="notes">
                      {({ field }) => (
                        <TextField
                          {...field}
                          id="outlined-basic"
                          label="Notas (opcional)"
                          placeholder='Escribe tus notas u observaciones'
                          variant="outlined"
                          multiline
                          rows={4}
                          fullWidth
                          value={values.notes}
                          onChange={handleChange}
                        />
                      )}
                    </Field>
                  </Grid>
                </Grid>
              </Box>
              <ErrorMessage name='isSubmitting' component={ErrorMessageStyled} />
              <div className='reservation-step-btn-container' style={{ display: 'flex', justifyContent: reservationStep === 0 ? 'flex-end' : 'space-evenly', width: '100%' }}>
                <Button variant='contained' onClick={(e) => nextStepHandler(e)} >
                  Siguiente
                </Button>
              </div>
              <div className='schedule-btn-container'>
                <ErrorMessage name='isSubmitting' component={ErrorMessageStyled} />
              </div>

            </Form>
          )}
        </Formik>
      </Box>
    </Box>
  );
});

export default EventFormBirthday;